import type {CSSProperties} from 'react'
import {useSearchParams} from 'react-router-dom'
import FreeEditorPage from '../components/FreeEditorPage'
import {EditorConfigProvider} from '../components/EditorConfigContext'
import useProjectSceneLoader from '../hooks/useProjectSceneLoader'

const FreeEditorRouteInner = () => {
  const [searchParams] = useSearchParams()
  const projectSlug = searchParams.get('project')
  const sceneIndex = parseInt(searchParams.get('scene') ?? '0', 10)

  useProjectSceneLoader(projectSlug, sceneIndex)

  return (
    <div style={fullViewportStyle}>
      <FreeEditorPage />
    </div>
  )
}

const FreeEditorRoute = () => (
  <EditorConfigProvider>
    <FreeEditorRouteInner />
  </EditorConfigProvider>
)

const fullViewportStyle: CSSProperties = {
  width: '100vw',
  height: '100dvh',
}

export default FreeEditorRoute
